import { useEffect, useState } from "react";
import DataGrid, { Column, Scrolling } from "devextreme-react/data-grid";
import { IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

import { dataGridConfig } from "../../../constants";
import { convertUTCTimeToLocal } from "../../../util/Utils";
import { DialogBox } from "../../CreateSites/DialogBox";
import EntityStepHistory from "./EntityStepHistory";

const CustomPermissionProcessDetails: React.FC<{ selectedProcessData: any, hqSiteId: number }> = (props: any) => {
  const [isDisplayModal, setIsDisplayModal] = useState(false);
  const [customPermissionProcessDetailsData, setCustomPermissionProcessDetailsData] = useState<any>(null);
  const [selectedEntityData, setSelectedEntityData] = useState<any>(null);

  useEffect(() => {
    if (props.selectedProcessData) {
      setCustomPermissionProcessDetailsData({
        pending: false,
        data: props.selectedProcessData?.entities,
        totalCount: props.selectedProcessData?.entities?.length,
      });
    }
  }, [props.selectedProcessData]);

  const handleEntityHistory = async (data: any) => {
    setSelectedEntityData(data);
    setIsDisplayModal(true);
  }

  const createdDateTime = (e: any) => {
    const raw = e?.value ?? e?.data?.lastUpdated;
    if (!raw) return null;

    return (
      <div style={{ display: "flex" }}>
        <div>
          <div>{convertUTCTimeToLocal(raw)}</div>
        </div>
      </div>
    );
  };

  const cellRenderStatusDetails = (e: any) => {
    return (
      <IconButton
        className="dx-datagrid dx-link"
        aria-label="See Details"
        title="See Details"
        onClick={() => handleEntityHistory(e.data)}
        sx={{
          padding: "2px",
          marginTop: "-5px",
          marginBottom: "-5px",
          fontSize: "16px",
        }}
      >
        <SearchIcon />
      </IconButton>
    );
  };

  const cellRenderLastModified = (e: any) => {
    return (
      <div style={{ display: "flex" }}>
        <div>{props?.selectedProcessData?.lastUpdatedBy}</div>
      </div>
    );
  }

  const handleClose = () => {
    setIsDisplayModal(false);
  };

  return (
    <div style={{ height: "400px" }}>
      <DataGrid
        {...dataGridConfig}
        dataSource={customPermissionProcessDetailsData?.data ?? []}
        showBorders={true}
        allowColumnResizing={true}
        showRowLines={true}
        columnAutoWidth={true}
        noDataText={
          customPermissionProcessDetailsData?.pending ? "Loading..." : "No Data"
        }
      >
        <Scrolling
          mode="virtual"
          scrollByContent={true}
          rowRenderingMode="virtual"
          showScrollbar={true}
        />
        <Column width={80} dataField="entityId" caption="Entity ID" allowSorting={true} />
        <Column dataField="entityName" caption="Entity Name" allowSorting={true} />
        <Column dataField="message" caption="Status" width={200} />
        <Column
          cellRender={cellRenderStatusDetails}
          type="buttons"
          caption="Status Details"
        />
        <Column dataField="lastModifiedBy" caption="Last Updated By" cellRender={cellRenderLastModified} />
        <Column
          cellRender={createdDateTime}
          dataField="lastUpdated"
          caption="Last Updated Date"
        />
        <DialogBox
          maxWidth="lg"
          isDisplayModal={isDisplayModal}
          handleClose={handleClose}
          title={"Entity History Details"}
          btnCloseTop={false}
          btnCloseText={"Close"}
        >
          <EntityStepHistory stepName={props.selectedProcessData?.stepName} hqSiteId={props.hqSiteId} entityId={selectedEntityData?.entityId} />
        </DialogBox>
      </DataGrid>
    </div>
  );
};

export default CustomPermissionProcessDetails;
